import { gql } from '@apollo/client';
const UPDATE_PRODUCT_EVENT = gql `
  mutation UpdateProductEvent(
    $productEventId: ID!
    $name: String!
    $description: String
    $thumbnail: String
  ) {
    updateProductEvent(
      productEventId: $productEventId
      name: $name
      description: $description
      thumbnail: $thumbnail
    ) {
      productEvent {
        id
        name
        description
        thumbnail
      }
    }
  }
`;
export default UPDATE_PRODUCT_EVENT;
